import { Component, ElementRef, EventEmitter, Output, Renderer2, ViewChild } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { ServicehotelService } from 'src/app/api/config/servicehotel.service';
import { SearchHotelComponent } from 'src/app/components/search-hotel/search-hotel.component';
import { ToolsService } from 'src/app/utils/tools.service';
import AlertifyHelper from 'src/app/utils/utils';
declare var $: any;
import * as moment from 'moment';
import * as _ from 'underscore';
import { HotelService } from 'src/app/api/tourism/hotel.service';
import { LoadingModalComponent } from 'src/app/components/loading-modal/loading-modal.component';

@Component({
  selector: 'app-bookings-hotel-extends',
  templateUrl: './bookings-hotel-extends.component.html',
  styleUrls: ['./bookings-hotel-extends.component.css']
})
export class BookingsHotelExtendsComponent {
  @Output() onSubmitEvent = new EventEmitter<string>();
  @ViewChild(SearchHotelComponent) SearchHotelComponent: any;
  @ViewChild(LoadingModalComponent) LoadingModalComponent: any;

  private thisComponent: BookingsHotelExtendsComponent;
  item: FormGroup;
  isEdit: boolean = false;
  submitted: boolean = false;
  bedroomSelected: any = null;

  hotelSelected: any = null;
  bedrooms: any = [];
  detail_bedrooms: any = [];

  total_booking: any = 0;

  constructor(
    public fb: FormBuilder,
    private renderer: Renderer2,
    private el: ElementRef,
    private serviceHotelService: ServicehotelService,
    private alertifyMsg: AlertifyHelper,
    public toolsService: ToolsService,
    public hotelService: HotelService,
  ) {
    this.thisComponent = this;

    this.item = this.fb.group({
      id: [null],
      index: [null],
      hotel_id: [null],
      observation: ['']
    });
  }

  // ngAfterViewInit(): void {
  //   this.SearchClientComponent.focused();
  // }

  get f(): { [key: string]: AbstractControl } {
    return this.item.controls;
  }

  loadData() {
    setTimeout(() => {
      this.SearchHotelComponent.focused();
    }, 550);
  }

  editData(item_:any, index_:any){
    this.isEdit = true;
    let component = this.thisComponent;
    this.LoadingModalComponent.show();
    this.item.patchValue({
      id: item_.id,
      index: index_,
    });
    this.hotelService.get(item_.hotel_id).subscribe({
      next: (data: any) => {        
        this.selectedHotelSearch(data.data);
        this.detail_bedrooms = item_.detail_bedrooms
        for(let index in this.detail_bedrooms ){
          setTimeout(() => {
            // date checkin =======
            (<any>$('#date_checkin' + index)).daterangepicker(
              {
                singleDatePicker: true,
                autoUpdateInput: false,
                showDropdowns: true,
                autoApply: true,
                locale: {
                  format: 'YYYY-MM-DD'
                }
              },
              function(chosen_date: any) {
                (<any>$('#date_checkin' + index)).val( chosen_date.format('YYYY-MM-DD'));
                component.detail_bedrooms[index].date_checkin = chosen_date.format('YYYY-MM-DD');
                component.detail_bedrooms[index].date_checkout = moment(chosen_date).add(1, 'days').format('YYYY-MM-DD');
                setTimeout(() => {
                  (<any>$('#date_checkout' + index)).val(component.detail_bedrooms[index].date_checkout);
                  component.initialDateCheckout(component.detail_bedrooms[index], component);
                }, 150);
              }
            );
            // date checkout =======
            (<any>$('#date_checkout' + index)).daterangepicker({
              singleDatePicker: true,       
              autoUpdateInput: false,
              showDropdowns: true,
              autoApply: true, 
              // startDate: moment(this.detail_bedrooms[index].date_checkin).add(1, 'days'),
              minDate: moment(this.detail_bedrooms[index].date_checkin).add(1, 'days'),
              locale: {
                  format: 'YYYY-MM-DD'
              }
              }, function (chosen_date:any) {
                  (<any>$('#date_checkout' + index)).val(  chosen_date.format('YYYY-MM-DD'));
                  component.detail_bedrooms[index].date_checkout = chosen_date.format('YYYY-MM-DD');
                  component.calculateNumberNights(index);
        
              });

              this.calculate_subtotal(index);

          }, 150);
        }
        
        this.LoadingModalComponent.hide();
      }
    });    
  }

  selectedHotelSearch(item_: any) {
    this.hotelSelected = item_;
    this.bedrooms = this.hotelSelected.hotelprices;
    this.item.patchValue({
      hotel_id: item_.id,
    });

    if (this.bedrooms.length > 0) {
      this.bedroomSelected = this.bedrooms[0].id;
    } else {
      this.bedroomSelected = null;
    }
  }

  removeHotel() {
    this.hotelSelected = null;
    this.bedrooms = [];
    this.detail_bedrooms = [];    
    this.item.patchValue({
      hotel_id: null,
    });
    setTimeout(() => {
      this.SearchHotelComponent.focused();
    }, 250);
    
  }

  addRateBedroom() {
    if (this.bedroomSelected != null) {
      let bedroom_ = this.toolsService.searchArrById(
        this.bedroomSelected,
        this.bedrooms
      );
      if (this.toolsService.notExistObjInArr(bedroom_, this.detail_bedrooms)) {
        bedroom_.typebedroom = bedroom_.description;
        bedroom_.date_checkin = null;
        bedroom_.date_checkout = null;
        bedroom_.price = bedroom_.price_corporate;
        bedroom_.guests = bedroom_.number_guests;
        bedroom_.quantity = 1;
        bedroom_.nights = 1;
        bedroom_.discount = 0;
        bedroom_.additional = 0;
        bedroom_.observation = null;
        bedroom_.subtotal = 0;
        bedroom_.is_paid = false;
        this.detail_bedrooms.push(bedroom_);

        setTimeout(() => {
          this.initialDateCheckin(bedroom_, this.thisComponent);
          this.initialDateCheckout(bedroom_, this.thisComponent);
        }, 150);
      } else {
        this.alertifyMsg.warning(
          'la habitación ' + bedroom_.description + ' ya se encuentra agregado'
        );
      }
    }
  }

  initialDateCheckin(item_:any, component: any){
    let index = this.detail_bedrooms.indexOf(item_);
    this.detail_bedrooms[index].date_checkin = moment().format('YYYY-MM-DD');
    (<any>$('#date_checkin' + index)).daterangepicker(
      {
        singleDatePicker: true,
        autoUpdateInput: false,
        showDropdowns: true,
        autoApply: true,
        // minDate: new Date(),
        locale: {
          format: 'YYYY-MM-DD'
        }
      },
      function(chosen_date: any) {
        (<any>$('#date_checkin' + index)).val(  chosen_date.format('YYYY-MM-DD'));
        component.detail_bedrooms[index].date_checkin = chosen_date.format('YYYY-MM-DD');
        component.detail_bedrooms[index].date_checkout = moment(chosen_date).add(1, 'days').format('YYYY-MM-DD');
        setTimeout(() => {
          (<any>$('#date_checkout' + index)).val(component.detail_bedrooms[index].date_checkout);
          component.initialDateCheckout(item_, component);
        }, 150);
      }
    );
  }

  initialDateCheckout(item_:any, component: any){
    let index = this.detail_bedrooms.indexOf(item_);
    this.detail_bedrooms[index].date_checkout = moment(this.detail_bedrooms[index].date_checkin).add(1, "days").format('YYYY-MM-DD');
    (<any>$('#date_checkout' + index)).daterangepicker({
          singleDatePicker: true,       
          autoUpdateInput: false,
          showDropdowns: true,
          autoApply: true, 
          startDate: moment(this.detail_bedrooms[index].date_checkin).add(1, 'days'),
          minDate: moment(this.detail_bedrooms[index].date_checkin).add(1, 'days'),
          locale: {
              format: 'YYYY-MM-DD'
          }
      }, function (chosen_date:any) {
          (<any>$('#date_checkout' + index)).val(  chosen_date.format('YYYY-MM-DD'));
          component.detail_bedrooms[index].date_checkout = chosen_date.format('YYYY-MM-DD');
          component.calculateNumberNights(index);

      });

      this.calculate_subtotal(index);
  }

  calculateNumberNights(index:any) {
      var date_checkout = moment((<any>$("#date_checkout" + index)).val(), 'YYYY-MM-DD');
      var date_checkin = moment((<any>$("#date_checkin" + index)).val(), 'YYYY-MM-DD');
      this.detail_bedrooms[index].nights = date_checkout.diff(date_checkin, 'days');
      this.calculate_subtotal(index);
  }


  changeGuests(param: any, index: number): void {
    let value_ = param.value;
    if (!_.isNaN(value_ * 1)) {
      this.detail_bedrooms[index].guests = value_;
    }
  }

  changeHotelsQuantity(param: any, index: number): void {
    let value_ = param.value;
    if (!_.isNaN(value_ * 1)) {
      this.detail_bedrooms[index].quantity = value_;
      this.calculate_subtotal(index);
    }
  }

  changeHotelsPrice(param: any, index: number): void {
    let value_ = param.value;
    if (!_.isNaN(value_ * 1)) {
      this.detail_bedrooms[index].price = value_;
      this.calculate_subtotal(index);
    }
  }

  changeHotelsDiscount(param: any, index: number): void {
    let value_ = param.value;
    if (!_.isNaN(value_ * 1)) {
      this.detail_bedrooms[index].discount = value_;
      this.calculate_subtotal(index);
    }
  }

  changeHotelsAdditional(param: any, index: number): void {
    let value_ = param.value;
    if (!_.isNaN(value_ * 1)) {
      this.detail_bedrooms[index].additional = value_;
      this.calculate_subtotal(index);
    }
  }

  changeHotelsObservation(param: any, index: number): void {
    let value_ = param.value;
    if (!_.isNaN(value_ * 1)) {
      this.detail_bedrooms[index].observation = value_;
    }
  }

  calculate_subtotal(index:any) {
    let item_ = this.detail_bedrooms[index];
    let cal_ = Number(item_.quantity) * Number(item_.price);
    let subtotal_ = ((cal_ * Number(item_.nights)) + Number(item_.additional) - Number(item_.discount)).toFixed(2);
    this.detail_bedrooms[index].subtotal = subtotal_;
    this.sum_items();
  }

  sum_items() {
    this.total_booking = 0;
    for (let i in this.detail_bedrooms) {
        this.total_booking = (Number(this.total_booking) + Number(this.detail_bedrooms[i].subtotal)).toFixed(2);
    }
    // $scope.text_amount = numero.letras($scope.total_book);
  };

  removeBedroom(index: any){
    this.detail_bedrooms.splice(index, 1);
    this.sum_items();
  }

  onSubmit() {
    this.submitted = true;
    if (this.item.invalid) {
      return;
    }
    let data: any = {};
    data.isEdit = this.isEdit;
    data.hotel = this.hotelSelected;
    data.total_booking = this.total_booking;
    data.item = this.item.value;
    data.detail_bedrooms = this.detail_bedrooms;
    if (this.validate()) {      
      this.LoadingModalComponent.show();
      this.onSubmitEvent.emit(data);
      this.LoadingModalComponent.hide();
      (<any>$('#openExtendsBookingHotel')).modal('hide');
      this.resetForm();
    }
  }

  validate() {
    let obj_ = this.item.value;
    if (_.isNull(obj_.hotel_id)) {
      this.alertifyMsg.warning('Debe seleccionar un hotel');
      this.SearchHotelComponent.focused();
      return false;
    }

    if (this.detail_bedrooms.length > 0) {
      for (let i in this.detail_bedrooms) {
        let _item = this.detail_bedrooms[i];
        // date checkin =============
        if (_.isNull(_item.date_checkin)) {
          this.alertifyMsg.warning( 'La fecha checkin ' +  _item.description + ' no puede estar vacío.' );
          this.renderer
            .selectRootElement(
              this.el.nativeElement.querySelector('#date_checkin' + i)
            )
            .focus();
          return false;
        }
        // date checkout ===========
        if (_.isNull(_item.date_checkout)) {
          this.alertifyMsg.warning( 'La fecha checkout ' +  _item.description + ' no puede estar vacío.' );
          this.renderer
            .selectRootElement(
              this.el.nativeElement.querySelector('#date_checkout' + i)
            )
            .focus();
          return false;
        }

         // nights ===========
        if (_.isNull(_item.nights)) {
          this.alertifyMsg.warning( 'El n° de noches ' +  _item.description + ' no puede estar vacío.' );
          this.renderer
            .selectRootElement(
              this.el.nativeElement.querySelector('#detailbedrooms_nights' + i)
            )
            .focus();
          return false;
        }

        // price corporate ===========
        if (_.isNull(_item.price)) {
            this.alertifyMsg.warning( 'El precio corporativo ' +  _item.description + ' no puede estar vacío.' );
            this.renderer
              .selectRootElement(
                this.el.nativeElement.querySelector('#detailbedrooms_price' + i)
              )
              .focus();
            return false;
        }
      }
    }else{
      this.alertifyMsg.warning("Debe seleccionar al menos una habitación");   
      return false;
    }

    return true;
  }

  resetForm() {
    this.submitted = false;
    this.isEdit = false;
    this.hotelSelected = null;
    this.detail_bedrooms = [];
    this.bedrooms = [];
    this.item.reset();
  }

  close() {
    // this.item.reset();
    this.resetForm();
  }
}
